import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ArrowDownIcon, ShieldCheckIcon, FileTextIcon, CalculatorIcon } from 'lucide-react';
import { WA_URL } from './constants';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-navy" data-id="element-78">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-79">
        <img src="https://images.unsplash.com/photo-1541888081622-15cb3a118f6c?auto=format&fit=crop&q=80" alt="Trabajador de construcción profesional" className="w-full h-full object-cover object-center opacity-40" data-id="element-80" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/80 to-transparent" data-id="element-81"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-20 pb-16" data-id="element-82">
        <div className="max-w-4xl mx-auto text-center" data-id="element-83">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-medium mb-8" data-id="element-84">
            <ShieldCheckIcon className="w-4 h-4 text-orange" data-id="element-85" />
            <span data-id="element-86">Mauricio Ramírez Construcciones</span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-87">
            Construcciones con garantía, seriedad y{' '}
            <span className="text-orange" data-id="element-88">presupuesto gratis</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-89">
            Mostramos tus ideas con claridad, trabajamos con compromiso y
            respaldamos cada proyecto con garantía de 5 años y contrato ante
            notaría.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12" data-id="element-90">
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-orange hover:bg-orange-hover text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 shadow-lg shadow-orange/25" data-id="element-91">
              <MessageCircleIcon className="w-5 h-5" data-id="element-92" />
              Solicitar presupuesto por WhatsApp
            </a>
            <a href="#galeria" className="w-full sm:w-auto flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 text-white border border-white/20 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 backdrop-blur-sm" data-id="element-93">
              Ver trabajos realizados
            </a>
          </motion.div>

          {/* Trust Microcopy */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm md:text-base text-gray-300 font-medium" data-id="element-94">
            <div className="flex items-center gap-2" data-id="element-95">
              <CalculatorIcon className="w-4 h-4 text-orange" data-id="element-96" />
              <span data-id="element-97">Presupuestos gratis</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-98">|</span>
            <div className="flex items-center gap-2" data-id="element-99">
              <FileTextIcon className="w-4 h-4 text-orange" data-id="element-100" />
              <span data-id="element-101">Contratos ante notaría</span>
            </div>
            <span className="hidden md:inline text-gray-600" data-id="element-102">|</span>
            <div className="flex items-center gap-2" data-id="element-103">
              <ShieldCheckIcon className="w-4 h-4 text-orange" data-id="element-104" />
              <span data-id="element-105">Garantía de 5 años</span>
            </div>
          </motion.div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce" data-id="element-106">
        <a href="#problema" className="text-white/50 hover:text-white transition-colors" data-id="element-107">
          <ArrowDownIcon className="w-6 h-6" data-id="element-108" />
        </a>
      </motion.div>
    </section>;
}